export const GET_SERVICEINIT_PAGE = 'serviceInitTypes/GET_SERVICEINIT_PAGE';
export const SET_SERVICEINIT_PAGE = 'serviceInitTypes/SET_SERVICEINIT_PAGE';
export const SET_SERVICEINIT_MENU = 'serviceInitTypes/SET_SERVICEINIT_MENU';
export const SET_SPINNER_STATUS = 'serviceInitTypes/SET_SPINNER_STATUS';
export const SET_MENU_INDEX = 'serviceInitTypes/SET_MENU_INDEX';
export const RESET_SERVICEINIT = 'serviceInitTypes/RESET_SERVICEINIT';
export const REFRESH_MENUS = 'serviceInitTypes/REFRESH_MENUS';
export const IS_LOADING_BATCH = 'serviceInitTypes/IS_LOADING_BATCH';
export const SUBMIT_BATCH_INIT_SUCCESS = 'serviceInitTypes/SUBMIT_BATCH_INIT_SUCCESS';
export const BATCH_INIT_PROGRESS_SUCCESS = 'serviceInitTypes/BATCH_INIT_PROGRESS_SUCCESS';
export const BATCH_INIT_SET_ERRORS = 'serviceInitTypes/BATCH_INIT_SET_ERRORS';
export const BATCH_INIT_SHOW_HIDE_ERRORS = 'serviceInitTypes/BATCH_INIT_SHOW_HIDE_ERRORS';
